/* eslint-disable max-len */
import 'react';
const PreviewImageAmplifySvg = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="#F9F9F9" fillRule="nonzero"><path d="M17 11.75a.75.75 0 01.102 1.493L17 13.25H8a.75.75 0 01-.102-1.493L8 11.75h9z" /><path d="M12.5 7.25a.75.75 0 01.743.648L13.25 8v9a.75.75 0 01-1.493.102L11.75 17V8a.75.75 0 01.75-.75z" /></g></svg>
);
export default PreviewImageAmplifySvg;
